export interface IDonorProfileCtScanData {
    donorId: number,
    donorAlias: string,
    hasCtScanOnline: boolean,
    canOrderCryo: boolean
}